import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { Flex, Icon, UiText } from '@shared/ui';

import cls from './EmptyCommentsPlaceholder.module.css';

interface IEmptyCommentsPlaceholderProps {
    className?: string;
}
export const EmptyCommentsPlaceholder = ({ className }: IEmptyCommentsPlaceholderProps) => {
    const { t } = useTranslation();

    return (
        <Flex
            fullWidth
            className={cn(cls.EmptyCommentsPlaceholderContainer, className)}
            direction="column"
            justify="center"
            gap={12}
        >
            <Icon iconName="comments" />
            <Flex direction="column">
                <UiText variant="subHeading" weight="bold" className={cls.EmptyCommentsHeader}>
                    {t('Comments.EmptyCommentsPlaceholder.Header')}
                </UiText>
                <UiText className={cls.EmptyCommentsDescription}>
                    {t('Comments.EmptyCommentsPlaceholder.Description')}
                </UiText>
            </Flex>
        </Flex>
    );
};
